import { render, staticRenderFns } from "./CustomizeCreatives.vue?vue&type=template&id=563d6ca5&"
import script from "./CustomizeCreatives.vue?vue&type=script&lang=ts&"
export * from "./CustomizeCreatives.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports